import { send } from "../api.js";

export type LessonAttendanceStatus = "present" | "late" | null;

export interface LessonAttendanceWriteResult {
  lessonId: string;
  attendanceStatus: LessonAttendanceStatus;
  updatedAt: string;
}

export function updateLessonAttendance(
  bookingId: string,
  attendanceStatus: LessonAttendanceStatus,
): Promise<LessonAttendanceWriteResult> {
  return send<LessonAttendanceWriteResult>(
    "PUT",
    `/admin/bookings/${encodeURIComponent(bookingId)}/lesson/attendance`,
    { attendanceStatus },
  );
}
